/**
 * Preset wood floor colors for the room-picker wizard.
 */

export type RoomFloorColorId =
  | "naturalPine"
  | "lightOak"
  | "goldenOak"
  | "honeyOak"
  | "naturalBeech"
  | "maple"
  | "ashWood"
  | "birch"
  | "walnut"
  | "darkWalnut"
  | "mahogany"
  | "cherryWood"
  | "teak"
  | "rosewood"
  | "wenge"
  | "darkWood";

export interface RoomFloorColorOption {
  id: RoomFloorColorId;
  /** i18n key under roomPicker.floorColors.* */
  labelKey: string;
  hex: string;
  /** THREE / area-fill fillColor as 0xRRGGBB */
  color: number;
}

const defineColor = (
  id: RoomFloorColorId,
  hex: string,
): RoomFloorColorOption => ({
  id,
  labelKey: id,
  hex,
  color: Number.parseInt(hex.replace("#", ""), 16),
});

export const ROOM_FLOOR_COLORS: RoomFloorColorOption[] = [
  defineColor("naturalPine", "#D8B07A"),
  defineColor("lightOak", "#D2B48C"),
  defineColor("goldenOak", "#C49A6C"),
  defineColor("honeyOak", "#B98B4A"),
  defineColor("naturalBeech", "#E3C39D"),
  defineColor("maple", "#D6A86A"),
  defineColor("ashWood", "#D8C3A5"),
  defineColor("birch", "#E5D3B3"),
  defineColor("walnut", "#6B4423"),
  defineColor("darkWalnut", "#4A2C1A"),
  defineColor("mahogany", "#6E2C1F"),
  defineColor("cherryWood", "#8B4513"),
  defineColor("teak", "#A67B5B"),
  defineColor("rosewood", "#65000B"),
  defineColor("wenge", "#3C2F2F"),
  defineColor("darkWood", "#4B3621"),
];

export const DEFAULT_ROOM_FLOOR_COLOR_ID: RoomFloorColorId = "naturalPine";

export const getRoomFloorColor = (
  id: RoomFloorColorId,
): RoomFloorColorOption =>
  ROOM_FLOOR_COLORS.find((option) => option.id === id) ?? ROOM_FLOOR_COLORS[0];
